import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyModule } from '@ngx-formly/core'; // This includes the FormlyAttributes directive
import { CheckboxV3Component } from '@gea/digital-ui-lib';

@Component({
  selector: 'formly-geaui-checkbox-v3',
  imports: [ReactiveFormsModule, FormlyModule, CheckboxV3Component],
  template: `
    <geaui-checkbox-v3
      [label]="props.label ?? ''"
      [disabled]="props['disabled'] ?? false"
      [formGroup]="formGroup"
      [formControlName]="getFormControlName()"
      [formlyAttributes]="field"></geaui-checkbox-v3>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeaUiCheckboxV3TypeComponent extends FieldType<FieldTypeConfig> {
  get formGroup(): FormGroup {
    return this.form as FormGroup;
  }

  getFormControlName(): string | null {
    return this.field?.key ? this.field.key.toString() : null;
  }
}
